import React, { FunctionComponent, useRef, useState } from "react";
import { Image, ListGroup, Overlay, Popover } from "react-bootstrap";
import { UserInfo } from "../../store/auth/types";
import { useDispatch } from "react-redux";
import { logoutUser, openEditProfileModal } from "../../store/auth/actions";
import { useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey, faPen, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { openChangePasswordModal } from "../../store/onboarding/cases/actions";

type OwnProps = {
  userInfo?: UserInfo;
};

type Props = OwnProps;

const UserActionsOverlay: FunctionComponent<Props> = ({ userInfo }) => {
  const buttonRef = useRef<HTMLDivElement | null>(null);
  const [showOverlay, setShowOverlay] = useState(false);
  const dispatch = useDispatch();
  const intl = useIntl();
  return (
    <>
      <Overlay
        target={buttonRef?.current as any}
        show={showOverlay}
        placement={"bottom"}
        rootClose
        rootCloseEvent={"click"}
        onHide={() => setShowOverlay(false)}
      >
        <Popover id="user-actions" className="user-actions-popover">
          <Popover.Content>
            <div className="popover-profile p-3" style={{ width: "350px" }}>
              <div className="d-flex align-items-center mb-3 profile-header-cover">
                  <Image
                    style={{ objectFit: "cover", objectPosition: "top center" }}
                    src={userInfo?.profile?.profile_image_url}
                    width={48}
                    height={48}
                    roundedCircle
                  />
                <div className="col">
                  <label className="font-weight-bold">{userInfo ? userInfo.first_name+' '+userInfo.last_name : ""}</label>
                  <label className="text-muted small">{userInfo ? userInfo.email : ""}</label>
                </div>
              </div>

              {/* Actions */}
              <ul className="list-unstyled mb-0">
                <li 
                  className="py-2 d-flex align-items-center font-weight-bold"
                  onClick={() => {
                    dispatch(openEditProfileModal());
                    setShowOverlay(false);
                  }}>
                  <FontAwesomeIcon icon={faPen} className="mr-2 pointer"/>
                  <label className="pointer">
                    {intl.formatMessage({
                      id: "app.dashboard.profile.editProfileBtn.label",
                    })}
                  </label>
                </li>

                <li 
                  className="py-2 d-flex align-items-center font-weight-bold"
                  onClick={() => {
                    dispatch(openChangePasswordModal());
                    setShowOverlay(false);
                  }}>
                  <FontAwesomeIcon icon={faKey} className="mr-2 pointer"/>
                  <label className="pointer">
                    {intl.formatMessage({
                      id: "app.dashboard.profile.changePasswordBtn.label",
                    })}
                  </label>
                </li>

                <hr className="my-2" />

                <li 
                  className="py-2 d-flex align-items-center font-weight-bold"
                  onClick={() => {
                    dispatch(logoutUser());
                    setShowOverlay(false);
                  }}
                >
                  <FontAwesomeIcon icon={faSignOutAlt} className="mr-2 pointer"/>
                  <label className="pointer">
                    {intl.formatMessage({
                      id: "app.dashboard.logoutBtn.label",
                    })}
                  </label>
                </li>
              </ul>
            </div>
          </Popover.Content>
        </Popover>
      </Overlay>
      <div onClick={() => setShowOverlay(true)} className="user-menu-item">
        <Image
          style={{ objectFit: "cover", objectPosition: "top center" }}
          src={userInfo?.profile?.profile_image_url}
          width={30}
          height={30}
          roundedCircle
        />
        <div ref={buttonRef} className="ml-2">{userInfo ? userInfo.first_name+' '+userInfo.last_name : ""}</div>
      </div>
    </>
  );
};

export default UserActionsOverlay;
